import { NavLink } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState } from "react";
import { useAppSettings } from '../hooks/useAppSettings';

const Menu = (props) => {
    const { user, logout, isAuthenticated } = useAuth0();
    const settings = useAppSettings();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (user && user[settings.roleClaim]) {
            setIsAdmin(Array.isArray(user[settings.roleClaim]) 
                ? user[settings.roleClaim].includes('admin')
                : user[settings.roleClaim] === 'admin');
        }
    }, [user, settings.roleClaim]);

    const links = [
        {
            name: 'Order',
            path: '/order-for-customer',
            adminOnly: true,
            weight: -1
        },
        {
            name: 'My Products',
            path: '/product-list',
            weight: 0
        },
        {
            name: 'Product Search',
            path: '/product-search',
            weight: 1
        },
        {
            name: 'My Account',
            path: '/account',
            weight: 2
        },
        {
            name: 'My Orders',
            path: '/orders',
            weight: 3
        },
    ];

    const filteredLinks = links
        .filter(link => !link.adminOnly || isAdmin)
        .sort((a, b) => a.weight - b.weight);

    function logoutUser() {
        logout({ returnTo: window.location.origin });
    }

    return (
            <ul className="nav-menu">
                {isAuthenticated && filteredLinks.map((link, index) => (
                    <li key={index} className='nav-menu_item' onClick={() => props.toggleMenu && props.toggleMenu()}>
                        <NavLink to={link.path} activeClassName="active">
                            {link.name}
                        </NavLink>
                    </li>
                ))}
                {isAuthenticated && (
                    <li className='nav-menu_item nav-menu_item-logout'>
                        <a onClick={() => logoutUser()}>Logout</a>
                    </li>
                )}
            </ul>
    );

}

export default Menu;